"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueprintStockedProduct = void 0;
const class_validator_1 = require("class-validator");
const pluralize = require("pluralize");
const StockedProduct_1 = require("./StockedProduct");
const trt_1 = require("../types/trt");
const trt_2 = require("../helpers/trt");
const pricingRules_1 = require("./pricingRules");
const Product_1 = require("./Product");
/**
 * Available ingredients on a product blueprint.
 */
class BlueprintStockedProduct extends StockedProduct_1.StockedProduct {
    constructor() {
        super(...arguments);
        this.category = Product_1.defaultProductCategory;
    }
    // TODO: move to zam specific
    getInvalidTrtIds(validTrtProductIds) {
        const trtIdNames = Object.keys(trt_1.TBlueprintStockedProductTrtIds);
        const trtIdKeys = Object.values(trt_1.TBlueprintStockedProductTrtIds);
        const invalidTrtIds = new Map();
        trtIdNames.forEach((trtIdName, index) => {
            const trtIdKey = trtIdKeys[index];
            const trtId = this[trtIdKey];
            if (!(0, trt_2.isValidTrtId)(trtId, validTrtProductIds)) {
                invalidTrtIds.set(trtIdKey, trtId);
            }
        });
        return invalidTrtIds;
    }
    /**
     *  Main text to show  based on the state of this ingredient selection
     *  examples:
     *    - complementary by category
     *      - no selection made = Add Chicken
     *      - complementary choice selected = Add extra main filling (Chicken)
     *      - not complementary choice selected = Add extra Chicken
     *    - complementary by item
     *      - no selection made = Add Cheese
     *      - selection made = Add extra Cheese
     */
    getAddLabel(salesOrderItem) {
        const { productId, title, category: { name } } = this;
        const { productBlueprint } = salesOrderItem;
        const { pricingRules } = productBlueprint;
        const availability = productBlueprint.productAvailabilityMap.get(productId);
        const isMainSelection = salesOrderItem.isMainSelection(this);
        const productHasComplementaryPricingRule = this.hasComplementaryCategoryPricingRule(pricingRules);
        const extraText = availability.isNowExtra ? "extra " : "";
        const buttonTitle = isMainSelection && productHasComplementaryPricingRule
            ? `Add ${extraText}main ${pluralize.singular(name)} (${title})`
            : `Add ${extraText}${title}`;
        return buttonTitle;
    }
    /**
     * Determines whether this product has a complementary by category pricing
     * rule
     */
    hasComplementaryCategoryPricingRule(pricingRules) {
        return pricingRules.some((pricingRule) => pricingRule.name === pricingRules_1.TPricingRuleName.complementaryByCategory &&
            pricingRule.category === this.category.name);
    }
    filterSensitiveData() {
        const clone = super.filterSensitiveData();
        // TODO: move to zam specific
        delete clone.addTrtId;
        delete clone.removeTrtId;
        return clone;
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { defaultLevel: this.defaultLevel, quantityPerServe: this.quantityPerServe, category: this.category, spiciness: this.spiciness, 
            // TODO: move to zam specific
            addTrtId: this.addTrtId, removeTrtId: this.removeTrtId });
    }
    static unserialize(data) {
        const newBlueprintStockedProduct = new this();
        newBlueprintStockedProduct.productId = data.productId;
        newBlueprintStockedProduct.retailLocationId = data.retailLocationId;
        newBlueprintStockedProduct.title = data.title;
        newBlueprintStockedProduct.description = data.description;
        newBlueprintStockedProduct.imageUrl = data.imageUrl;
        newBlueprintStockedProduct.retailPrice = data.retailPrice;
        newBlueprintStockedProduct.dietaryInfo = data.dietaryInfo;
        newBlueprintStockedProduct.retailLocationId = data.retailLocationId;
        newBlueprintStockedProduct.currentStockLevel = data.currentStockLevel;
        newBlueprintStockedProduct.isStandalone = data.isStandalone;
        newBlueprintStockedProduct.defaultLevel = data.defaultLevel;
        newBlueprintStockedProduct.quantityPerServe = data.quantityPerServe;
        newBlueprintStockedProduct.category = data.category;
        newBlueprintStockedProduct.spiciness = data.spiciness;
        // TODO: move to zam specific
        newBlueprintStockedProduct.trtId = data.trtId;
        newBlueprintStockedProduct.addTrtId = data.addTrtId;
        newBlueprintStockedProduct.removeTrtId = data.removeTrtId;
        return newBlueprintStockedProduct;
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.IsNotEmpty)()
], BlueprintStockedProduct.prototype, "defaultLevel", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsNotEmpty)()
], BlueprintStockedProduct.prototype, "quantityPerServe", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)()
], BlueprintStockedProduct.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(3)
], BlueprintStockedProduct.prototype, "spiciness", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)()
], BlueprintStockedProduct.prototype, "addTrtId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)()
], BlueprintStockedProduct.prototype, "removeTrtId", void 0);
exports.BlueprintStockedProduct = BlueprintStockedProduct;
//# sourceMappingURL=BlueprintStockedProduct.js.map